import React, { useContext, useEffect, useState } from 'react';
import { Box, Grid, Paper, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { Field, Formik, Form } from 'formik';
import { object, string } from 'yup';
import { Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useNavigate, useParams } from 'react-router-dom';
import OrdersContext from '../Context/Orders/OrdersContext';
import DateTime from '../Components/NewOrderDialog/DateTime';
import PieCounter from '../Components/NewOrderDialog/PieCounter';

export default function OrderEdit() {
	const { orders, editOrder, isLoading, toogleIsLoading } =
		useContext(OrdersContext);
	const navigate = useNavigate();

	const { orderId } = useParams();
	const [currentOrderEdit, setCurrentOrderEdit] = useState();

	useEffect(() => {
		if (!currentOrderEdit) {
			orders.map((order) => {
				if (order.id === orderId) {
					setCurrentOrderEdit(order);
				}
			});
		}
	}, []);

	return (
		<>
			{currentOrderEdit && (
				<Paper
					elevation={0}
					sx={{
						display: 'inline-table',
						backgroundColor: '#F0F0F0',
						borderRadius: '8px 8px 0px 0px',
						height: 'calc( -64px + 100vh)',
						marginTop: '8px',
						boxShadow: '0px 0px 6px 3px rgba(0,0,0,0.30)',
						padding: '24px',
					}}
				>
					<Formik
						initialValues={currentOrderEdit}
						validationSchema={object({
							name: string()
								.required('Es un campo requerido')
								.min(1, 'El folio debe contener mínimo 1 carácteres'),
							placeOfDelivery: string().required('Es un campo requerido'),
						})}
						validateOnMount
					>
						{({
							errors,
							isValid,
							touched,
							dirty,
							values,
							// resetForm,
							setFieldValue,
							// validateForm,
						}) => (
							<Form>
								<Field
									InputProps={{
										inputProps: { className: 'edit' },
									}}
									required
									margin='dense'
									id='name'
									name='name'
									value={values.name}
									as={TextField}
									label='Nombre'
									type='text'
									fullWidth
									variant='outlined'
									error={errors.name && touched.name}
									helperText={touched.name && errors.name}
								/>
								<Field
									multiline
									margin='dense'
									id='description'
									name='description'
									value={values.description}
									as={TextField}
									label='Descripción'
									type='text'
									fullWidth
									variant='outlined'
								/>
								<DateTime
									disablePast
									value={values.dateOfDelivery}
									onChange={(newValue) => {
										if (newValue !== null) {
											setFieldValue('dateOfDelivery', dayjs(newValue).format());
										} else {
											setFieldValue('dateOfDelivery', null);
										}
									}}
									id='dateOfDelivery'
									name='dateOfDelivery'
									label='Fecha de entrega'
									variant='outlined'
									renderInput={(props) => (
										<TextField {...props} fullWidth margin='dense' required />
									)}
								/>
								<Field
									required
									margin='dense'
									id='placeOfDelivery'
									name='placeOfDelivery'
									value={values.placeOfDelivery}
									as={TextField}
									label='Lugar de entrega'
									type='text'
									fullWidth
									variant='outlined'
									error={errors.placeOfDelivery && touched.placeOfDelivery}
									helperText={touched.placeOfDelivery && errors.placeOfDelivery}
								/>
								<Grid container>
									{values?.items
										?.sort((a, b) => a.id - b.id)
										.map(({ name, label, value, id, category }) => (
											<Grid item xs={12} xsm={6} key={name}>
												{category === 'whole' ? (
													<Field
														// eslint-disable-next-line react/no-unstable-nested-components
														as={PieCounter}
														margin='dense'
														id={name}
														name={`items[${id}].value`}
														onChange={(e) => {
															setFieldValue(
																`items[${id}].value`,
																e.target.value
															);
														}}
														value={value}
														text={`${label}`}
														type='number'
														fullWidth
														variant='outlined'
														InputProps={{
															inputProps: {
																min: 0,
																style: { textAlign: 'center' },
															},
														}}
													/>
												) : (
													<Field
														// eslint-disable-next-line react/no-unstable-nested-components
														as={PieCounter}
														margin='dense'
														id={name}
														name={`items[${id}].value`}
														onChange={(e) => {
															setFieldValue(
																`items[${id}].value`,
																e.target.value
															);
														}}
														value={value}
														text={`${label} (rebanada)`}
														type='number'
														fullWidth
														variant='outlined'
														InputProps={{
															inputProps: {
																min: 0,
																style: { textAlign: 'center' },
															},
														}}
													/>
												)}
											</Grid>
										))}
								</Grid>
								<Box
									sx={{
										margin: '0 auto',
										padding: '16px 0 8px 0',
										textAlign: 'center',
									}}
								>
									<LoadingButton
										disabled={
											!(
												isValid &&
												dirty &&
												(values.items[0].value ||
													values.items[1].value ||
													values.items[2].value ||
													values.items[3].value)
											)
										}
										onClick={() => {
											toogleIsLoading(true);
											editOrder(orderId, values, navigate);
										}}
										endIcon={<Save />}
										loading={isLoading}
										loadingPosition='end'
										variant='contained'
									>
										Guardar cambios
									</LoadingButton>
								</Box>
							</Form>
						)}
					</Formik>
				</Paper>
			)}
		</>
	);
}
